<template lang="pug">
    section.intro

        .intro__background.rellax(data-rellax-speed='5')

            .intro__slogan-wrapper
                .intro__slogan-container
                    .intro__slogan-empty

                    .intro__slogan(:class='{animate: pageLoaded}')
                        p.intro__slogan-text СПЕЦПРОЕКТ – <br class="intro__slogan-br" />ВЫБЕРИТЕ СВОЮ «МИСС ОФИС»!
                        span.intro__slogan-huge ‘20

                    .intro__slogan-sign(:class='{animate: pageLoaded}') На фото: Елизавета Знагован - Мисс Офис 2019

            .intro__image
                .intro__image-self(:class='{animate: pageLoaded}')

        #about.intro__information.rellax(data-rellax-speed='8')
            .intro__text-wrapper(:class='{animate: pageLoaded}')
                p.intro__text(
                    v-html='description'
                    )

        .intro__scrolldown-wrapper(:class='{animate: pageLoaded}')
            svg.intro__scrolldown-arrow(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 33.36 18.75' width='33.36' height='18.75')
                path(fill='#1d1d1b' d='M2.05 0L0 2.05l14.63 14.63-.02.02 2.05 2.05.02-.02.02.02 2.05-2.05-.02-.02L33.36 2.05 31.31 0 16.68 14.63 2.05 0z')

</template>

<script>
import {mapGetters} from 'vuex';
import {scrolltext, description} from '@/assets/data/data.json';
import Rellax from 'rellax';

export default {
    name: 'Intro',

    data() {
        return {
            scrolltext,
            description,
            rellaxInst: null
        };
    },

    mounted() {
        window.addEventListener('resize', this.reinitRellaxBlocks);
        if (this.isMobile()) return;
        this.initRellax();
    },

    computed: {
        ...mapGetters(['pageLoaded'])
    },

    methods: {
        initRellax() {
            this.rellaxInst = new Rellax('.rellax', {
                center: false,
                wrapper: null,
                round: true,
                vertical: true,
                horizontal: false
            });
        },

        reinitRellaxBlocks() {
            if (this.isMobile() && this.rellaxInst) this.destroyRellaxInst();
            if (!this.isMobile() && !this.rellaxInst) this.initRellax();
        },

        destroyRellaxInst() {
            this.rellaxInst.destroy();
            this.rellaxInst = null;
        },

        isMobile() {
            return window.screen.width <= 769 ? true : false;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';

@keyframes arrowBounce {
    0% {
        transform: translateY(10px);
    }

    50% {
        transform: translateY(-10px);
    }

    100% {
        transform: translateY(10px);
    }
}

.intro {
    position: relative;
    width: 100%;
    max-height: calc(var(--vh, 1vh) * 100);
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    align-items: stretch;
    font-size: 18px;
    line-height: 38px;

    @media (--viewport-tablet) {
        flex-direction: column;
        max-height: unset;
    }

    &__slogan-wrapper {
        position: absolute;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        left: 0;
        top: 0;
        z-index: 30;

        @media (--viewport-tablet) {
            justify-content: center;
        }
    }

    &__slogan-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        transform: translateX(calc(var(--slogan-size-main) / 2));

        @media (--viewport-laptop-xl) {
            transform: translateX(calc(var(--slogan-size-mac) / 2));
        }

        @media (--viewport-tablet) {
            transform: none;
            align-items: center;
            margin: 0 4.5vw;
        }
    }

    &__slogan-empty {
        height: 38px;
        width: 1px;
    }

    &__background {
        position: relative;
        width: 50%;
        height: 100vh;
        background-color: var(--color-bg-pink);
        z-index: 5;
    }

    &__slogan {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        font-size: 1.25vw;
        font-family: var(--font-accent);
        font-weight: 400;
        line-height: 46px;
        // transform: translateX(calc(var(--slogan-size-main) / 2));
        z-index: 2;

        &:after {
            content: '';
            display: inline-block;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 2px;
            background: black;
            transform: scaleX(0);
            transform-origin: 0% 0%;
            transition: transform 1s ease-out 4s;

            @media (--viewport-laptop-xl) {
                height: 1px;
            }
        }

        &-br {
            display: none;
        }

        &-huge {
            font-family: var(--font-accent);
            font-size: 7.416em;
            font-weight: 300;
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.6s ease 3s, transform 1.6s ease-out 2.8s;
        }

        &-text {
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.6s ease 2.8s, transform 1.6s ease-out 2.6s;
        }

        &-sign {
            font-size: 16px;
            padding-bottom: calc(var(--vh, 1vh) * 3);
            text-align: left;
            opacity: 0;
            transform: translateY(25px);
            transition: opacity 1s ease 2.8s, transform 1.2s ease-out 2.6s;
            align-self: flex-start;

            @media (--viewport-laptop-l) {
                font-size: 1.16vw;
            }

            @media (--viewport-tablet) {
                font-size: 1.3em;
                text-align: center;
                padding-bottom: calc(var(--vh, 1vh) * 9);
                align-self: center;
            }

            @media (--viewport-mobile-l) {
                font-size: 12px;
            }

            &.animate {
                opacity: 1;
                transform: translateY(0px);
            }
        }

        &.animate {
            &:after {
                transform: scaleX(1);
            }
            .intro {
                &__slogan {
                    &-huge,
                    &-text {
                        opacity: 1;
                        transform: translateY(0px);
                    }
                }
            }
        }

        @media (--viewport-laptop-xl) {
            font-size: 1.39vw;
            // transform: translateX(calc(var(--slogan-size-mac) / 2));
            border-width: 1px;
        }

        @media (--viewport-tablet) {
            width: 100%;
            margin: 0 4.5vw;
            font-size: 3.6vw;
            transform: none;
            align-items: flex-end;
            line-height: 40px;

            &-br {
                display: block;
            }

            &-huge {
                line-height: 0.85em;
            }
        }

        @media (--viewport-mobile-l) {
            margin: 0 7vw;
            font-size: 3.85vw;

            &-huge {
                line-height: 1em;
            }
        }
    }

    &__image {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;

        &-self {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            background-image: url('../assets/img/intro1.jpg');
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            background-size: 100%;
            mix-blend-mode: darken;
            opacity: 0;
            transform: scale(1.3);
            transform-origin: 50% 50%;
            transition: opacity 3s ease 2.8s, transform 3s ease-out 2.2s;

            &.animate {
                opacity: 1;
                transform: scale(1);
            }
        }
    }

    &__information {
        text-align: justify;
        width: 50%;
        background-color: var(--color-bg-pink);
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        @media (--viewport-tablet) {
            padding: 15vh 10.4vw;
            width: 100%;
            background: none;
        }
    }

    &__text-wrapper {
        opacity: 0;
        transition: opacity 2.6s ease 3s;

        &.animate {
            opacity: 1;
        }
    }

    &__text {
        font-size: 1.3vw;
        line-height: 1.9;
        padding: 0 8.5vw;

        @media (--viewport-tablet) {
            font-size: 1.5em;
            line-height: 1.4;
            padding: 0;
        }

        @media (--viewport-mobile-l) {
            font-size: 16px;
        }
    }

    &__scrolldown-wrapper {
        position: absolute;
        width: 100%;
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        top: 0;
        left: 0;
        z-index: 8;
        pointer-events: none;

        opacity: 0;
        transform: translateY(50px);
        transition: opacity 0.6s ease 2.8s, transform 1.6s ease-out 2.2s;

        &.animate {
            opacity: 1;
            transform: translateY(0px);
        }
    }

    &__scrolldown-arrow {
        position: absolute;
        bottom: 32px;
        left: calc(50% - 16.68px);
        animation: arrowBounce 5s infinite ease-in-out;
    }

    @media (--viewport-laptop-l) {
        &__image-self {
            background-position: center center;
            background-size: cover;
        }
    }

    @media (--viewport-tablet) {
        &__image-self {
            background-position: 30% 45%;
            background-size: 100%;
        }

        &__background {
            width: 100%;
        }
    }
    @media (--viewport-mobile-l) {
        &__image-self {
            background-position: top center;
            background-size: cover;
        }
    }
}
</style>
